import { Play, Plus } from "lucide-react";

const EqBars = () => (
  <div className="flex items-end gap-[2px] h-3">
    {[7, 12, 5].map((h, i) => (
      <div key={i} className="w-[2px] rounded-sm bg-white" style={{ height: h }} />
    ))}
  </div>
);

export const VariantRow = ({
  label,
  durationLabel,
  color,
  isActive,
  isPlaying,
  queuePosition,
  onPlay,
  onToggleQueue,
}) => {
  const isQueued = queuePosition > -1;

  return (
    <div
      onClick={onPlay}
      className="flex items-center gap-3 rounded-xl px-2.5 py-2 cursor-pointer transition-colors"
      style={{ background: isActive ? "rgba(255,255,255,.1)" : "rgba(255,255,255,.03)" }}
    >
      <div
        className="w-7 h-7 rounded-full flex items-center justify-center shrink-0"
        style={{ background: isActive ? color : "rgba(255,255,255,.12)" }}
      >
        {isActive && isPlaying ? <EqBars /> : <Play size={10} fill="currentColor" className="text-white" />}
      </div>

      <span className="text-[13px] font-semibold text-white/90 flex-1 min-w-0 truncate">{label}</span>
      <span className="text-[11px] font-mono text-white/40 shrink-0">{durationLabel}</span>

      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggleQueue();
        }}
        className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 text-[11px] font-bold"
        style={{
          background: isQueued ? "#e0217a" : "rgba(255,255,255,.1)",
          color: isQueued ? "#fff" : "rgba(255,255,255,.5)",
        }}
        title={isQueued ? "Quitar de mi lista" : "Agregar a mi lista"}
      >
        {isQueued ? queuePosition + 1 : <Plus size={12} />}
      </button>
    </div>
  );
};
